import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  MoveRight, 
  ShieldCheck, 
  Mountain, 
  Users, 
  ThermometerSun 
} from "lucide-react";

const stats = [
  {
    icon: <ShieldCheck className="w-5 h-5" />,
    label: "Safety First",
    value: "100% Summit Safety",
    detail: "Certified local guides equipped with emergency protocols on every high-pass."
  },
  {
    icon: <Mountain className="w-5 h-5" />,
    label: "Engineering",
    value: "Acclimatization Buffers",
    detail: "Our itineraries are scientifically paced with built-in adaptation days to maximize success at high altitude."
  },
  {
    icon: <Users className="w-5 h-5" />, 
    label: "Expertise",
    value: "Experienced & Trusted",
    detail: "Led by senior local guides with 100s of successful summits and deep-rooted knowledge of every trail secret."
  },
  {
    icon: <ThermometerSun className="w-5 h-5" />,
    label: "Best Timing",
    value: "Mar–May | Oct–Dec",
    detail: "Strictly scheduled treks to align with stable high-pressure systems and peak mountain visibility."
  }
];

const TrustSection = () => {
  const navigate = useNavigate();

  const handlePhilosophyClick = (e) => {
    e.preventDefault();
    navigate("/about-us");
    // Wait for the route to render, then scroll
    setTimeout(() => {
      const target = document.getElementById("philosophy");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 120);
  };

  return (
    <section className="py-20 bg-white border-y border-black/5 px-6">
      <div className="max-w-6xl mx-auto">
        
        {/* Statistics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="flex flex-col space-y-4">
              {/* Icon Container */}
              <div className="text-[#C99D89] bg-[#C99D89]/10 w-10 h-10 rounded-full flex items-center justify-center">
                {stat.icon}
              </div>
              
              {/* Content */}
              <div>
                <p className="text-[10px] uppercase tracking-[0.4em] text-[#575C3E]/50 font-bold mb-1">
                  {stat.label}
                </p>
                <h4 className="text-xl font-serif text-[#575C3E] mb-2 italic">
                  {stat.value}
                </h4>
                <p className="text-[11px] text-[#575C3E]/70 leading-relaxed font-light">
                  {stat.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Footer Link */}
        <div className="mt-16 flex justify-center">
          <button 
            onClick={handlePhilosophyClick}
            className="group flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.3em] text-[#575C3E] transition-all hover:text-[#C99D89]"
          >
            Our Trekking Philosophy 
            <MoveRight className="w-4 h-4 group-hover:translate-x-2 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TrustSection; 